import { configureStore } from "@reduxjs/toolkit";
import { accidentReducer } from "./slices/accidentSlice";
const store = configureStore({
  reducer: {
    accident: accidentReducer,
  },
});

export default store;
